/* global angular, moment */
/**
 * Created by lari on 08/06/2017.
 */

// This MUST remain a directive, compnets do not allow placement as Attribute
// use in index.html as <body heartbeat>
(function () {
  'use strict';
  
  /**
   * @ngdoc directive
   * @name heartbeat.directive:heartbeat
   * @restrict A
   * @element
   *
   * @description detects backend outages and warns user
   *
   *
   * @example
   <html name="index.html">
   <body heartbeat></body>
   </html>
   *
   */
  angular
    .module('vcutils.heartbeat')
    .directive('heartbeat', heartbeat);
  
  
  heartbeat.$inject = ['$log', 'vertxEventBusService', '$state', '$rootScope', '$interval', '$window', '$timeout', '$uibModal'];
  
  function heartbeat($log, vertxEventBusService, $state, $rootScope, $interval, $window, $timeout, $uibModal) {
    return {
      restrict: 'A',
      scope: {},
      replace: false,
      controllerAs: 'heartbeat',
      controller: function () {
        let vm = this;
        vm.name = 'heartbeat';
        vm.refresh = refresh;

        function refresh () {
          $window.location.reload();
        }

        $interval(function () {
          // $log.debug('timout called');
          if (angular.isUndefined($rootScope.connfailure)) {
            $rootScope.connfailure = 0;
          }
          
          // $log.debug('heartbeat : ', $rootScope.heartbeat.isBetween(moment().subtract(5, 'second'), moment()));
          
          if (angular.isDefined($rootScope.heartbeat)) {
            if ($rootScope.heartbeat.isBetween(moment().subtract(500, 'ms'), moment())) {
              // $log.debug('connection exists');
              $rootScope.connfailure = 0;
            }
            else {
              // $log.debug('connection failed');
              $rootScope.connfailure++;
            }
            
            if ($rootScope.connfailure >= 3) {
              if (angular.isUndefined($rootScope.connalert)) {
                $rootScope.connalert = $uibModal.open({
                  template: '<div class="modalspacer">' +
                  '<div class="alert alert-danger" ng-hide="connfailure === 0">' +
                  '<h1 style="text-align: center"><i class="fa fa-warning"></i> Die Verbindung zum Server wurde unterbrochen!</h1>' +
                  '<h3 style="text-align: center">Dieser Hinweis verschwindet, sobald der Fehler behoben ist.</h3>' +
                  '<div class="spacer-top"><h3>Fehlerbehebung</h3>' +
                  '<ul><li>Bitte 2 Minuten warten, Verbindungsfehler beheben sich oft von alleine.</li>' +
                  '<li>Bei WLAN/VPN Verbindungen (Handy, Tablet, Laptop) WLAN/VPN abdrehen, wieder neu verbinden und 1 Minute warten.</li>' +
                  '<li>Strg + R drücken (CMD + R für Mac), oder hier <span class="btn btn-danger" ng-click="vm.refresh()"><span class="fa fa-refresh"></span> Seite neu laden</span> </li>' +
                  '</ul></div></div>' +
                  '<div class="alert alert-success" ng-show="connfailure === 0">' +
                  '<h1 style="text-align: center"><i class="fa fa-check"></i> Die Verbindung zum Server wurde wieder hergestellt!</h1>' +
                  '<h3>Je nach dem wo Sie gerade gearbeitet haben, kann es zu Datenverlust der letzten 10 Sekunden gekommen sein.' +
                  'Bitte überprüfen und ggf. nochmal eintragen.</h3>' +
                  '<button class="btn btn-success" ng-click="connalert.close()">Weiterabeiten</button>' +
                  '</div></div>',
                  size: 'lg',
                  backdrop: 'static',
                  controllerAs: 'miCtrl',
                  bindToController: true,
                  controller: function () {
                    $log.debug('modal $scope: ', $rootScope);
                    // this an empty controller - weird
                    let vmi = this;
                    vmi.$rootScope = $rootScope;
                  },
                  resolve: {}
                });
              } else {
                $log.debug('%%%% $rootscope.connalert already existed: ', $rootScope.connalert);

              }
            }
          }
          
        }, 1000);
        
      },
      link: function (scope, element, attrs, ctrl) {
        /* jshint unused:false */
        /* eslint "no-unused-lets": [2, {"args": "none"}] */
        
        vertxEventBusService.on('heartbeat', function (msg) {
          $rootScope.heartbeat = moment();
          // $log.debug('heartbeat caught: ', $rootScope.heartbeat);
        });
        
        
      }
    };
  }
}());
